const $ = jQuery;
var page = 1;

$(document).ready(function () {
    const lazyVideoSelector = 'video.js-lazy-video';
    const lazyVideoObserver = 'IntersectionObserver' in window
        ? new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                const video = entry.target;

                if (entry.isIntersecting) {
                    if (video.dataset.loaded !== 'true') {
                        video.querySelectorAll('source[data-src]').forEach(function (source) {
                            source.src = source.dataset.src;
                            source.removeAttribute('data-src');
                        });

                        if (video.dataset.src) {
                            video.src = video.dataset.src;
                            video.removeAttribute('data-src');
                        }

                        video.dataset.loaded = 'true';
                        video.load();
                    }

                    if (video.autoplay && video.paused) {
                        const playPromise = video.play();
                        if (playPromise) playPromise.catch(function () {});
                    }
                } else if (video.dataset.loaded === 'true' && video.autoplay && !video.paused) {
                    video.pause();
                }
            });
        }, {
            rootMargin: '300px 0px',
            threshold: 0.01,
        })
        : null;

    function initializeLazyVideos(root) {
        const videos = [];

        if (root.nodeType === 1 && root.matches(lazyVideoSelector)) {
            videos.push(root);
        }

        if (root.querySelectorAll) {
            root.querySelectorAll(lazyVideoSelector).forEach(function (video) {
                videos.push(video);
            });
        }

        videos.forEach(function (video) {
            if (video.dataset.lazyVideoInitialized === 'true') return;

            video.dataset.lazyVideoInitialized = 'true';

            if (lazyVideoObserver) {
                lazyVideoObserver.observe(video);
            } else {
                video.querySelectorAll('source[data-src]').forEach(function (source) {
                    source.src = source.dataset.src;
                    source.removeAttribute('data-src');
                });

                if (video.dataset.src) {
                    video.src = video.dataset.src;
                    video.removeAttribute('data-src');
                }

                video.dataset.loaded = 'true';
                video.load();
            }
        });
    }

    initializeLazyVideos(document);

    if ('MutationObserver' in window) {
        const lazyVideoMutationObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    initializeLazyVideos(node);
                });
            });
        });

        lazyVideoMutationObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    let filterScrollTriggerRefreshFrame = null;

    function refreshFilterScrollTriggers($results) {
        const scheduleRefresh = function () {
            window.cancelAnimationFrame(filterScrollTriggerRefreshFrame);
            filterScrollTriggerRefreshFrame = window.requestAnimationFrame(function () {
                filterScrollTriggerRefreshFrame = window.requestAnimationFrame(function () {
                    filterScrollTriggerRefreshFrame = null;

                    if (window.ScrollTrigger) {
                        window.ScrollTrigger.refresh(true);
                    }
                });
            });
        };

        scheduleRefresh();

        if ($results && $results.length) {
            $results.find('img').filter(function () {
                return !this.complete;
            }).off('.filterScrollTrigger').one(
                'load.filterScrollTrigger error.filterScrollTrigger',
                scheduleRefresh
            );
        }
    }

    function lockFilterResultsHeight($results) {
        const currentHeight = $results.outerHeight();

        if (currentHeight > 0) {
            $results.css('min-height', `${Math.ceil(currentHeight)}px`);
        }

        $results.attr('aria-busy', 'true');
    }

    function releaseFilterResultsHeight($results) {
        window.requestAnimationFrame(function () {
            $results.css('min-height', '');
            $results.attr('aria-busy', 'false');
            refreshFilterScrollTriggers($results);
        });
    }

    $('.two-col-text-image-carousel').each(function () {
        const $section = $(this);
        const $gallery = $section.find('.image-gallery-slider');
        if (!$gallery.length || $gallery.hasClass('slick-initialized')) return;

        $gallery.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            adaptiveHeight: true,
            arrows: true,
            dots: false,
            prevArrow: $section.find('.gallery-slider-arrows .prev'),
            nextArrow: $section.find('.gallery-slider-arrows .next'),
        });

        $gallery.find('img').on('load', function () {
            $gallery.slick('setPosition');
        });
    });

    // Showpass renders these controls as spans rather than native buttons.
    $('.ticket-button-shortcode span.open-ticket-widget, .ticket-button-shortcode span.open-calendar-widget').each(function () {
        const control = this;
        control.setAttribute('tabindex', '0');
        control.setAttribute('role', 'button');

        control.addEventListener('pointerdown', function () {
            control.focus({ preventScroll: true });
        });
        control.addEventListener('keydown', function (event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            if (event.repeat || control.getAttribute('aria-disabled') === 'true') return;
            if (event.key === 'Enter') control.click();
        });
        control.addEventListener('keyup', function (event) {
            if (event.key !== ' ') return;
            event.preventDefault();
            if (control.getAttribute('aria-disabled') !== 'true') control.click();
        });
    });

    $('.slider-instagram-feed').each(function () {
        const $section = $(this);
        const $previousButton = $section.find('.instagram-feed-control-prev');
        const $nextButton = $section.find('.instagram-feed-control-next');
        let wheelDelta = 0;
        let attempts = 0;
        let refreshFrame = null;
        let refreshPaintFrame = null;
        let feedResizeObserver = null;
        let observedSectionHeight = 0;

        const refreshFeedScrollTriggers = () => {
            window.cancelAnimationFrame(refreshFrame);
            window.cancelAnimationFrame(refreshPaintFrame);
            refreshFrame = window.requestAnimationFrame(() => {
                refreshPaintFrame = window.requestAnimationFrame(() => {
                    refreshFrame = null;
                    refreshPaintFrame = null;
                    if (window.ScrollTrigger) {
                        window.ScrollTrigger.refresh(true);
                    }
                });
            });
        };

        const initialiseFeedSlider = () => {
            const $feed = $section.find('#sbi_images');
            const $photos = $feed.find('.sbi_photo');
            const feedImagesReady = $photos.length && $photos.toArray().every((photo) => {
                const hasBackgroundImage = photo.style.backgroundImage && photo.style.backgroundImage !== 'none';
                const image = photo.querySelector('img');

                return hasBackgroundImage || (image && image.currentSrc);
            });

            if (!$feed.length || !$feed.find('.sbi_item').length || !feedImagesReady || $feed.hasClass('slick-initialized')) {
                return false;
            }

            // Slick changes the feed height after the page's initial trigger measurements.
            $feed.on('init.instagramFeed reInit.instagramFeed', refreshFeedScrollTriggers);

            $feed.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                centerMode: true,
                centerPadding: '0px',
                swipeToSlide: true,
                swipe: true,
                touchMove: true,
                draggable: true,
                arrows: false,
                dots: false,
            });

            if (window.ResizeObserver && !feedResizeObserver) {
                observedSectionHeight = Math.round($section[0].getBoundingClientRect().height);
                feedResizeObserver = new ResizeObserver(function () {
                    const nextHeight = Math.round($section[0].getBoundingClientRect().height);

                    if (nextHeight === observedSectionHeight) return;

                    observedSectionHeight = nextHeight;
                    refreshFeedScrollTriggers();
                });
                feedResizeObserver.observe($section[0]);
            }

            $previousButton.on('click', function () {
                $feed.slick('slickPrev');
            });
            $nextButton.on('click', function () {
                $feed.slick('slickNext');
            });

            $feed.on('wheel.instagramFeed', function (event) {
                const originalEvent = event.originalEvent;
                const horizontalDelta = originalEvent.deltaX || (originalEvent.shiftKey ? originalEvent.deltaY : 0);

                // Keep regular vertical page scrolling intact.
                if (!horizontalDelta) {
                    return;
                }

                event.preventDefault();
                wheelDelta += horizontalDelta;

                if (Math.abs(wheelDelta) < 40) {
                    return;
                }

                $feed.slick(wheelDelta > 0 ? 'slickNext' : 'slickPrev');
                wheelDelta = 0;
            });

            return true;
        };

        // Smashing Balloon can populate its feed after the document has loaded.
        const feedReadyTimer = window.setInterval(() => {
            attempts += 1;

            if (initialiseFeedSlider() || attempts >= 40) {
                window.clearInterval(feedReadyTimer);
            }
        }, 250);
    });

    $('.slider-image-text-slides').each(function () {
        const $section = $(this);
        const $slider = $section.find('.image-text-slides');

        if (!$slider.length || $slider.hasClass('slick-initialized')) {
            return;
        }

        $slider.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            centerMode: true,
            centerPadding: '0px',
            swipeToSlide: true,
            swipe: true,
            touchMove: true,
            draggable: true,
            arrows: false,
            dots: false,
        });

        let wheelDelta = 0;

        $slider.on('wheel.imageTextSlides', function (event) {
            const originalEvent = event.originalEvent;
            const horizontalDelta = originalEvent.deltaX || (originalEvent.shiftKey ? originalEvent.deltaY : 0);

            // Keep normal vertical page scrolling intact.
            if (!horizontalDelta) {
                return;
            }

            event.preventDefault();
            wheelDelta += horizontalDelta;

            if (Math.abs(wheelDelta) < 40) {
                return;
            }

            $slider.slick(wheelDelta > 0 ? 'slickNext' : 'slickPrev');
            wheelDelta = 0;
        });

        $section.find('.slider-arrows .prev').on('click', function () {
            $slider.slick('slickPrev');
        });
        $section.find('.slider-arrows .next').on('click', function () {
            $slider.slick('slickNext');
        });
    });

    const $window = $(window);
    const $body = $('body');
    const $header = $('header.site-header');
    const $headerContainer = $header.find('.header-container').first();
    const $topMenuBar = $header.find('.top-menu-bar').first();
    const $hamburger = $('.hamburger');
    const $navigation = $('header .navigation-container');
    let lockedScrollPosition = 0;

    const updateHeaderHeight = () => {
        if (!$header.length) {
            return;
        }

        const isMobileViewport = $window.width() < 1024;
        const headerContainerHeight = $headerContainer.outerHeight() || 0;
        const topMenuBarHeight = !isMobileViewport && $topMenuBar.length ? ($topMenuBar.outerHeight() || 0) : 0;
        const baseHeaderHeight = headerContainerHeight + topMenuBarHeight;

        document.documentElement.style.setProperty('--site-header-height', `${baseHeaderHeight}px`);
    };

    const updateMobileNavigationHeight = () => {
        if (!$navigation.length) {
            return;
        }

        const navigationTop = $navigation[0].getBoundingClientRect().top;
        const availableHeight = Math.max(window.innerHeight - navigationTop, 0);
        $navigation.css('--mobile-nav-height', `${availableHeight}px`);
    };

    const refreshMobileNavigationLayout = () => {
        updateMobileNavigationHeight();
    };

    const openMobileNavigation = () => {
        lockedScrollPosition = window.scrollY || window.pageYOffset || 0;
        $hamburger.addClass('is-active').attr('aria-expanded', 'true').attr('aria-label', 'Close menu');
        $header.addClass('has-mobile-nav-open');
        updateHeaderHeight();
        $navigation.addClass('active');
        refreshMobileNavigationLayout();
        window.requestAnimationFrame(refreshMobileNavigationLayout);
        window.setTimeout(refreshMobileNavigationLayout, 275);
        $body
            .addClass('remove-scroll')
            .css('top', `${lockedScrollPosition * -1}px`);
    };

    const closeMobileNavigation = () => {
        const scrollPosition = Math.abs(parseInt($body.css('top'), 10)) || lockedScrollPosition || 0;
        $hamburger.removeClass('is-active').attr('aria-expanded', 'false').attr('aria-label', 'Open menu');
        $navigation.removeClass('active');
        $navigation.find('.header-submenu.active').removeClass('active');
        $header.removeClass('has-mobile-nav-open has-mobile-submenu-open');
        $body.removeClass('remove-scroll').css('top', '');
        window.scrollTo(0, scrollPosition);
        lockedScrollPosition = 0;
        updateHeaderHeight();
        refreshMobileNavigationLayout();
    };

    $('.menu-btn').click(function () {
        if ($hamburger.hasClass('is-active')) {
            closeMobileNavigation();
            return;
        }

        openMobileNavigation();
    });

    $window.on('resize', function () {
        updateHeaderHeight();

        if ($window.width() >= 1024 && $hamburger.hasClass('is-active')) {
            closeMobileNavigation();
            return;
        }

        if ($window.width() >= 1024) {
            $header.removeClass('has-mobile-nav-open has-mobile-submenu-open');
        } else if ($navigation.hasClass('active')) {
            $header.addClass('has-mobile-nav-open');
        }

        refreshMobileNavigationLayout();
    });

    $window.on('load', function () {
        updateHeaderHeight();
        refreshMobileNavigationLayout();
    });

    updateHeaderHeight();
    refreshMobileNavigationLayout();

    $('body').on('click', '.accordion-trigger', function () {
        const $trigger = $(this);
        const $item = $trigger.closest('.accordion-item').length ? $trigger.closest('.accordion-item') : $trigger;
        const $panel = $item.find('.accordion-panel').first();
        const $panelInner = $panel.find('.accordion-panel-inner').first();
        const isExpanded = $trigger.attr('aria-expanded') === 'true' || $item.hasClass('active');

        const closeAccordion = ($accordionItem) => {
            const $accordionTrigger = $accordionItem.hasClass('accordion-trigger')
                ? $accordionItem
                : $accordionItem.find('.accordion-trigger').first();
            const $accordionPanel = $accordionItem.find('.accordion-panel').first();
            const $accordionPanelInner = $accordionPanel.find('.accordion-panel-inner').first();
            const currentHeight = $accordionPanelInner.outerHeight() || 0;

            $accordionItem.removeClass('active');
            $accordionTrigger.removeClass('active').attr('aria-expanded', 'false');

            if ($accordionPanel.length) {
                $accordionPanel.css('height', currentHeight + 'px');

                window.requestAnimationFrame(function () {
                    $accordionPanel.css('height', '0px');
                });

                window.setTimeout(function () {
                    if (!$accordionItem.hasClass('active')) {
                        $accordionPanel.attr('hidden', true);
                    }
                }, 220);
            }
        };

        if (isExpanded) {
            closeAccordion($item);
            return;
        }

        if (!$item.closest('.accessibility-guide-page').length) {
            $('.accordion-item.active, .accordion-trigger.active').each(function () {
                const $activeItem = $(this).hasClass('accordion-item')
                    ? $(this)
                    : $(this).closest('.accordion-item').length
                        ? $(this).closest('.accordion-item')
                        : $(this);

                if ($activeItem.length && !$activeItem.is($item)) {
                    closeAccordion($activeItem);
                }
            });
        }

        $item.addClass('active');
        $trigger.addClass('active').attr('aria-expanded', 'true');

        if ($panel.length) {
            $panel.attr('hidden', false);

            window.requestAnimationFrame(function () {
                const height = $panelInner.outerHeight() || 0;
                $panel.css('height', height + 'px');
            });
        }
    });

    $('.nav-inner .parent-item').click(function (e) {
        if ($window.width() >= 1024) {
            return;
        }

        const megaMenuBox = $(this).find('.header-submenu');
        const target = $(e.target);

        if (!megaMenuBox.length || target.is('a') || target.closest('a').length) {
            return;
        }

        $('.nav-inner .header-submenu.active').not(megaMenuBox).removeClass('active');
        megaMenuBox.toggleClass('active');
    });

    $('.submenu-container .sub-menu-arrow-btn').on('mouseenter', function () {
        showSubMenu($(this));
    });

    $('.submenu-container .sub-menu-arrow-btn').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).closest('.submenu-links-wrapper').find('#sub-menu-col').removeClass('active');
        } else {
            showSubMenu($(this));
        }
    });

    $('.nav-inner .parent-item').on('mouseenter', function () {
        $('.submenu-container .sub-menu-arrow-btn.active').removeClass('active');
        $('.submenu-links-wrapper #sub-menu-col.active').removeClass('active');
    });

    const showSubMenu = (btn) => {
        const links = btn.data('links');
        const subMenu = btn.closest('.submenu-links-wrapper').find('#sub-menu-col');
        $('.submenu-container .sub-menu-arrow-btn.active').removeClass('active');
        btn.addClass('active');

        if (links.toString() !== subMenu.data("last-list")) {
            subMenu.attr('data-last-list', links.toString());
            const list = subMenu.find('.menu-items-list');
            let newHTML = "";
            links.forEach((elm) => {
                newHTML += `<li>
                <a href="${elm.url}">${elm.title}</a>                
                </li>`;
            });
            list.html(newHTML);
            subMenu.addClass('active');
        }
    }

    $(window).scroll(function () {
        if ($(document).scrollTop() > 100) {
            $('body').addClass('scroll');
        } else {
            $('body').removeClass('scroll');
        }
    });

    $('#newsletter-form').on('submit', function (event) {
        event.preventDefault();
        var data = {
            'action': 'add_mailchimp',
            'name': $('#newsletter-form input[name="name"]').val(),
            'email': $('#newsletter-form input[name="email"]').val()
        };

        $.ajax({
            type: 'POST',
            url: window.location.origin + "/wp-admin/admin-ajax.php",
            data: data,
        }).done(function (data) {
            console.log(data);
            $('.success-text').text('Thank you for subscribing to our newsletter!');
            $('#newsletter-form').trigger("reset");
        });
    });
    // Home Pop Up Mail Chimp API Call
    $('#popup-newsletter').on('submit', function (event) {
        event.preventDefault();
        var data = {
            'action': 'add_mailchimp',
            'name': $('#popup-newsletter input[name="name"]').val(),
            'email': $('#popup-newsletter input[name="email"]').val()
        };

        $.ajax({
            type: 'POST',
            url: window.location.origin + "/wp-admin/admin-ajax.php",
            data: data,
        }).done(function (data) {
            console.log(data);
            $('.promotion-popup .success-text').text('Thank you for subscribing to our newsletter!');
            $('#popup-newsletter').trigger("reset");
        });
    });

    $('.faq-page .select-btn').on('click', function () {
        const $faqResults = $('.faq-results');

        $('.faq-page .select-btn').each(function () {
            $(this).removeClass('active');
        });
        $(this).addClass('active');

        let data = {
            'action': 'load_faq',
            'id': $(this).attr("data-id")
        };

        lockFilterResultsHeight($faqResults);
        $faqResults.html('<p class="faq-request-status text-center" role="status">Loading FAQs…</p>');

        $.ajax({
            type: 'POST',
            url: window.location.origin + "/wp-admin/admin-ajax.php",
            data: data,
        }).done(function (data) {
            $faqResults.html(data);
        }).always(function () {
            releaseFilterResultsHeight($faqResults);
        });
    });

    // Filter Vendor Show / Hide (Mobile)
    $('.vendor-filter-mobile-btn button').on('click', function () {
        $('.vendor-filter-part, .et-filter-part').each(function () {
            const $filters = $(this);
            $filters.css('display', $filters.css('display') === 'none' ? 'flex' : 'none');
        });
        $(this).toggleClass('active');
    })

    // Keep search, filters, sorting and pagination together for each vendor request.
    const $vendorsPage = $('.vendors-page');
    const $vendorResults = $vendorsPage.find('.vendor-results');
    if ($vendorsPage.length && $vendorResults.length) {
        const $results = $vendorResults;
        const $search = $vendorsPage.find('input[name="vendor-search"]');
        const $sort = $vendorsPage.find('#vendor-sort');
        const filterButtons = 'button.select-btn[data-id], button.vendor-food-btn[data-id]';
        let vendorPage = 1;
        let shuffleSeed = Math.floor(Math.random() * 2147483646) + 1;
        let pendingRequest = null;
        let requestVersion = 0;
        let searchTimer = null;
        let needsRefresh = false;
        const $status = $('<p class="vendor-request-status text-center" role="status"></p>').insertBefore($results);

        $results.masonry({
            itemSelector: '.masonry-grid-item',
            columnWidth: '.masonry-grid-item',
            percentPosition: true,
            isFitWidth: false
        });

        function refreshVendorLayout() {
            $results.masonry('layout');
            refreshFilterScrollTriggers($results);
        }

        function layoutVendors() {
            refreshVendorLayout();
            if (typeof $results.imagesLoaded === 'function') {
                $results.imagesLoaded().progress(refreshVendorLayout);
            }
            $results.find('img').off('load.vendorLayout').on('load.vendorLayout', function () {
                refreshVendorLayout();
            });
            $results.find('video').off('loadedmetadata.vendorLayout').on('loadedmetadata.vendorLayout', function () {
                refreshVendorLayout();
            });
        }
        layoutVendors();

        function activeIds(selector) {
            return $vendorsPage.find(selector).map(function () {
                return $(this).attr('data-id');
            }).get();
        }

        function cancelVendorRequest() {
            requestVersion++;
            if (pendingRequest) {
                pendingRequest.abort();
                pendingRequest = null;
            }
        }

        function loadVendors(append = false) {
            if (append && (pendingRequest || needsRefresh)) return;
            clearTimeout(searchTimer);
            cancelVendorRequest();
            const version = requestVersion;
            const nextPage = append ? vendorPage + 1 : 1;
            const $button = $results.find('.vendor-load-more');
            const data = {
                action: 'filter_vendor',
                page: nextPage,
                search: $search.val().trim(),
                sort: $sort.val() || 'az',
                shuffle_seed: shuffleSeed,
                type_filters: activeIds('button.select-btn[data-id].active:not(.vendor-food-btn)'),
                food_filters: activeIds('button.vendor-food-btn[data-id].active'),
                source_page_id: $vendorsPage.data('source-id') || 0,
                quote_index: append ? Number($button.attr('data-next-quote-index')) || 0 : 0,
                rendered_count: append ? Number($button.attr('data-rendered-count')) || 0 : 0
            };
            $button.prop('disabled', true);
            if (!append) lockFilterResultsHeight($results);
            $status.text('Loading vendors…');

            pendingRequest = $.ajax({
                type: 'POST',
                url: window.location.origin + '/wp-admin/admin-ajax.php',
                data: data
            }).done(function (markup) {
                if (version !== requestVersion) return;
                if (append) {
                    $results.find('.load-more-content').remove();
                    $results.append(markup);
                } else {
                    $results.html(markup);
                }
                vendorPage = nextPage;
                needsRefresh = false;
                $results.masonry('reloadItems');
                layoutVendors();
                $status.empty();
            }).fail(function (xhr, status) {
                if (version !== requestVersion || status === 'abort') return;
                $status.text('Could not load vendors. ');
                $('<button type="button" class="theme-btn small">Try again</button>')
                    .appendTo($status).on('click', function () { loadVendors(append); });
            }).always(function () {
                if (version !== requestVersion) return;
                pendingRequest = null;
                releaseFilterResultsHeight($results);
                $results.find('.vendor-load-more').prop('disabled', needsRefresh);
            });
        }

        function refreshVendors(delay = 0) {
            needsRefresh = true;
            clearTimeout(searchTimer);
            cancelVendorRequest();
            $results.find('.vendor-load-more').prop('disabled', true);
            if (delay) {
                searchTimer = setTimeout(function () { loadVendors(); }, delay);
            } else {
                loadVendors();
            }
        }

        $search.on('input', function () { refreshVendors(250); });
        $sort.on('change', function () {
            if ($sort.val() === 'rand') shuffleSeed = Math.floor(Math.random() * 2147483646) + 1;
            refreshVendors();
        });
        $vendorsPage.on('click', filterButtons + ', button.all-btn', function () {
            if ($(this).hasClass('all-btn')) {
                $vendorsPage.find(filterButtons).removeClass('active');
            } else {
                $(this).toggleClass('active');
            }
            $vendorsPage.find('button.all-btn').toggleClass('active',
                !$vendorsPage.find(filterButtons).filter('.active').length);
            refreshVendors();
        });
        $vendorsPage.on('click', '.vendor-load-more', function (event) {
            event.preventDefault();
            loadVendors(true);
        });

        // Apply all URL filters before issuing a single request.
        const vendorParams = new URLSearchParams(window.location.search);
        const requestedTypes = (vendorParams.get('type') || '').split(',');
        const requestedId = vendorParams.get('filter');
        let hasUrlFilters = false;
        $vendorsPage.find('button.select-btn[data-id]').each(function () {
            const $button = $(this);
            if (requestedTypes.includes($button.attr('data-type')) ||
                (requestedId && $button.attr('data-id') === requestedId)) {
                $button.addClass('active');
                hasUrlFilters = true;
            }
        });
        if (hasUrlFilters) {
            $vendorsPage.find('button.all-btn').removeClass('active');
            refreshVendors();
        } else if ($search.val().trim() || ($sort.val() || 'az') !== 'az') {
            refreshVendors();
        }
    }

    const $vendorMainSlider = $('.main-slide-for');
    const $vendorNavSlider = $('.vendor-image-slider');
    if ($vendorMainSlider.length) {
        $vendorMainSlider.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            asNavFor: $vendorNavSlider
        });
    }
    if ($vendorNavSlider.length) {
        $vendorNavSlider.slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            asNavFor: $vendorMainSlider,
            prevArrow: '<button class="slick-prev vendor-slider-arrow" type="button" aria-label="Previous image"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M7.46484 1.21875L1.32555 6.97433C0.904142 7.36941 0.904143 8.03833 1.32555 8.43341L7.46484 14.189" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>',
            nextArrow: '<button class="slick-next vendor-slider-arrow" type="button" aria-label="Next image"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M7.46484 1.21875L1.32555 6.97433C0.904142 7.36941 0.904143 8.03833 1.32555 8.43341L7.46484 14.189" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>',
            focusOnSelect: true
        });
    }

    $('.vendor-image-slider').on('click', 'img', function () {
        const newSrc = $(this).attr('src');
        $('.vendor-image').attr('src', newSrc);
    });

    const $activitiesSlider = $('.activities-slider');
    if ($activitiesSlider.length) {
        $activitiesSlider.slick({
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            dots: false,
            adaptiveHeight: true,
            prevArrow: '<button class="slick-prev activity-slider-arrow" type="button" aria-label="Previous image"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M7.46484 1.21875L1.32555 6.97433C0.904142 7.36941 0.904143 8.03833 1.32555 8.43341L7.46484 14.189" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>',
            nextArrow: '<button class="slick-next activity-slider-arrow" type="button" aria-label="Next image"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M7.46484 1.21875L1.32555 6.97433C0.904142 7.36941 0.904143 8.03833 1.32555 8.43341L7.46484 14.189" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
            ]
        });
    }

    const popupQueue = [];
    let activePopup = null;

    function openNextPopup() {
        if (activePopup || !popupQueue.length) return;

        activePopup = popupQueue.shift();
        const $popup = $(activePopup);

        if (typeof activePopup.showModal !== 'function') {
            activePopup = null;
            openNextPopup();
            return;
        }

        activePopup.showModal();
        $('body').addClass('has-popup-open');
        window.requestAnimationFrame(function () {
            $popup.addClass('active');
        });
    }

    function closePopup(popupElement) {
        const $popup = $(popupElement);
        $popup.removeClass('active');

        if (popupElement.open) {
            popupElement.close();
        }
    }

    $('.promotion-popup').each(function () {
        const popupElement = this;
        const $popup = $(popupElement);
        const popupKey = $popup.data('popup-key') || 'popup';
        const popupVersion = $popup.attr('data-popup-version') || '1';
        const savedPopupVersion = getCookie(popupKey);

        if (savedPopupVersion && savedPopupVersion !== popupVersion) {
            setCookie(popupKey, '', -1);
        }

        if (savedPopupVersion !== popupVersion) {
            popupQueue.push(popupElement);
        }

        $popup.on('click', function (event) {
            if (event.target !== popupElement) return;

            const bounds = popupElement.getBoundingClientRect();
            const clickedBackdrop = event.clientX < bounds.left ||
                event.clientX > bounds.right ||
                event.clientY < bounds.top ||
                event.clientY > bounds.bottom;

            if (clickedBackdrop) {
                closePopup(popupElement);
            }
        });

        $popup.find('.close-btn').on('click', function () {
            closePopup(popupElement);
        });

        $popup.on('close', function () {
            $popup.removeClass('active');
            setCookie(popupKey, popupVersion);
            if (activePopup === popupElement) {
                activePopup = null;
            }
            if (!$('.promotion-popup[open]').length) {
                $('body').removeClass('has-popup-open');
            }
            window.setTimeout(openNextPopup, 5000);
        });

        $popup.on('cancel', function () {
            $popup.removeClass('active');
        });
    });

    if (popupQueue.length) {
        window.setTimeout(openNextPopup, 3000);
    }


    $('#popup-newsletter').on('submit', function (event) {
        event.preventDefault();
    });


    $('body').on('click', '.buy-btn', function () {
        'use strict'
        !(function (a, e) {
            if (!a.aap) {
                a.aap = function (e) {
                    ; (a.acuityAdsEventQueue = a.acuityAdsEventQueue || []).push(e)
                }
                var t = 'script'
                var i = e.createElement(t)
                i.async = true
                i.src = 'https://origin.acuityplatform.com/event/v2/pixel.js'
                var c = e.getElementsByTagName(t)[0]
                c.parentNode.insertBefore(i, c)
                a.acuityPiggybackCallback = function (e) {
                    a.acuityParseResponse(e)
                }
            }
        })(window, document)
        aap({ pixelKey: '1529473886844603129', pg: 32373 })
    });


    // Plan your Visit
    $(".services-layout-section").hide();
    function activateTab(tabId) {
        $('.services-layout-section').hide();
        $('.services-item').removeClass('active');
        $(tabId).fadeIn();

        // Find related button and activate it
        var index = tabId.replace('#PlanYourVisit', '');
        $('.services-item[target="' + index + '"]').addClass('active');

        // Scroll to wrapper with header offset
        var headerHeight = $('.site-header').outerHeight() || 0;
        var targetOffset = $('.services-section-wrapper').offset().top - headerHeight;
        $('html, body').animate({
            scrollTop: targetOffset
        }, 600);
    }

    // On click event
    $('.services-item').click(function (e) {
        e.preventDefault();
        var tabId = '#PlanYourVisit' + $(this).attr('target');
        window.location.hash = tabId; // update URL hash
        activateTab(tabId);
    });
    // On page load, check if hash exists
    if (window.location.hash) {
        var tabId = window.location.hash;
        if ($(tabId).length) {
            activateTab(tabId);
        }
    }
    // Same page handle hash without reload
    $(window).on('hashchange', function () {
        var tabId = window.location.hash;
        if ($(tabId).length) {
            activateTab(tabId);
        }
    });

    // FAQ Accordion ~ TAB
    $(".faqTabSection").hide();
    $(".faqTabSection:first").show();
    $(".faq-chip-tab .theme-btn:first").addClass("active");
    $(".faq-chip-tab .theme-btn").click(function (e) {
        e.preventDefault();
        var headerHeight = $(".site-header").outerHeight() || 0;
        var targetID = $(this).attr("href");
        // Hide all and show the clicked one
        $(".faqTabSection").hide();
        $(targetID).fadeIn();
        // Active class handling
        $(".faq-chip-tab .theme-btn").removeClass("active");
        $(this).addClass("active");
        // Smooth scroll
        if ($(targetID).length) {
            var targetTabSectionOffset = $(targetID).offset().top - headerHeight;
            $("html, body").animate(
                {
                    scrollTop: targetTabSectionOffset,
                },
                600
            );
        }
    });

    // Experience Page
    const mainBase = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        fade: true,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 4000
    };
    const navBase = {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        focusOnSelect: true
    };

    // --- Helper: init sliders for a specific tab (scoped) ---
    function initTab($tab) {
        const $main = $tab.find('.christmas-slick-slider');
        const $nav = $tab.find('.slider-event-nav');
        const $textLinks = $tab.find('.christmas-slider-text a[data-slide]');

        if (!$main.length || !$nav.length) return;

        // Guard: avoid double init
        if ($main.hasClass('slick-initialized')) $main.slick('unslick');
        if ($nav.hasClass('slick-initialized')) $nav.slick('unslick');

        // Init pair (scope asNavFor by element not selector)
        $main.slick({ ...mainBase, asNavFor: $nav });
        $nav.slick({ ...navBase, asNavFor: $main });

        // Sync text links on init and after every change
        // Remove any previous namespaced listeners, then bind
        $main.off('init.sync afterChange.sync')
            .on('init.sync afterChange.sync', function (event, slick, currentSlide) {
                // On 'init', Slick passes currentSlide as undefined; use slick.currentSlide
                const idx = typeof currentSlide === 'number' ? currentSlide : (slick.currentSlide || 0);
                $textLinks.removeClass('active');
                $textLinks.filter('[data-slide="' + (idx + 1) + '"]').addClass('active');
            });

        // Manually trigger 'init' sync once Slick finishes initializing
        // (Slick fires 'init' before this handler attaches if we call .slick() first)
        const currentIdx = $main.slick('slickCurrentSlide') || 0;
        $textLinks.removeClass('active');
        $textLinks.filter('[data-slide="' + (currentIdx + 1) + '"]').addClass('active');
    }

    // --- Initial tab setup ---
    const $tabs = $('.christmas-tab-body');
    if ($tabs.length) {
        $tabs.hide();

        const $firstTab = $tabs.first().show();
        initTab($firstTab);

        $('.christmas-slider-text a:first-child').addClass('active');
        $('.tab-area a:first-child').addClass('active');
        $('.event-slider-cta').on('click', function () {
            const targetId = '#christmasTab' + $(this).attr('target');
            const $targetTab = $(targetId);
            // UI state
            $tabs.hide();
            $('.event-slider-cta').removeClass('active');
            $(this).addClass('active');

            // Reset text link actives only inside the target tab; init will set the correct one
            $tabs.find('.christmas-slider-text a').removeClass('active');

            // Show + init only the target tab
            $targetTab.show();
            initTab($targetTab);
        });
    }

    // --- Text links -> go to slide (scoped to the visible tab only) ---
    $('.christmas-slider-text').on('click', 'a[data-slide]', function (e) {
        e.preventDefault();
        const slideno = (Number($(this).data('slide')) || 1) - 1;
        const $visibleTab = $('.christmas-tab-body:visible');
        const $main = $visibleTab.find('.christmas-slick-slider.slick-initialized');
        // Update active state only inside the visible tab
        $visibleTab.find('.christmas-slider-text a').removeClass('active');
        $(this).addClass('active');
        if ($main.length) {
            $main.slick('slickGoTo', slideno, true);
        }
    });

    // Add Class in Header Experience Page
    // if ($('body').hasClass('page-template-experience-page') || $('body').hasClass('page-template-new-home-page')) {
    //     $('header.site-header').removeClass('red-bg');
    //     $(window).on('scroll', function () {
    //         if ($(this).scrollTop() >= 80) {
    //             $('header.site-header').addClass('red-bg');
    //         } else {
    //             $('header.site-header').removeClass('red-bg');
    //         }
    //     });
    // }

    // Video AutoPlay & Mute functionality
    var video = $("#homeVideo")[0];
    if (video) {
        video.muted = true;

        $(".mute-on-off-btn").on("click", function () {
            video.muted = !video.muted;
            $(this).toggleClass("off");
        });
    }

    // Home Testimonial Slider
    var $homeSliderTestimonial = $('.HomeTestimonialSlider');
    if ($homeSliderTestimonial.length) {
        $homeSliderTestimonial.slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            pauseOnHover: false,
            pauseOnFocus: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
        });
        $('.home-testimonial-slider .slider-arrows .prev').on('click', function () {
            $homeSliderTestimonial.slick('slickPrev');
        });
        $('.home-testimonial-slider .slider-arrows .next').on('click', function () {
            $homeSliderTestimonial.slick('slickNext');
        });
    }

    $('.slider-image-text-hover').each(function () {
        const $section = $(this);
        const $imageHoverSlider = $section.find('.image-hover-slider');

        if (!$imageHoverSlider.length || $imageHoverSlider.hasClass('slick-initialized')) {
            return;
        }

        $imageHoverSlider.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            swipeToSlide: true,
            swipe: true,
            touchMove: true,
            draggable: true,
            arrows: false,
            dots: false,
        });

        const slick = $imageHoverSlider.slick('getSlick');
        const getDefaultLeft = slick.getLeft.bind(slick);
        const getDefaultDotCount = slick.getDotCount.bind(slick);
        let terminalIndex = 0;
        let terminalLeft = 0;

        const updateTerminalPosition = () => {
            const contentWrapper = $section.find('.content-wrapper').get(0);
            const list = slick.$list.get(0);
            const slides = slick.$slides.toArray();
            const lastSlide = slides[slides.length - 1];

            if (!contentWrapper || !list || !lastSlide) {
                return;
            }

            const listRect = list.getBoundingClientRect();
            const contentRect = contentWrapper.getBoundingClientRect();
            const listPaddingLeft = parseFloat(window.getComputedStyle(list).paddingLeft) || 0;
            const lastSlideRight = lastSlide.offsetLeft + $(lastSlide).outerWidth(true);
            const availableRight = contentRect.right - listRect.left - listPaddingLeft;
            const requiredOffset = Math.max(lastSlideRight - availableRight, 0);

            terminalLeft = requiredOffset * -1;
            terminalIndex = slides.findIndex((slide) => slide.offsetLeft >= requiredOffset);
            terminalIndex = -1 === terminalIndex ? slides.length - 1 : terminalIndex;
        };

        // Slick's variable-width mode otherwise allows the final card to reach the left edge.
        slick.getLeft = function (slideIndex) {
            if (slideIndex >= terminalIndex) {
                return terminalLeft;
            }

            return getDefaultLeft(slideIndex);
        };
        slick.getDotCount = function () {
            return Math.min(getDefaultDotCount(), terminalIndex);
        };

        updateTerminalPosition();
        $(window).on('resize.imageHoverSliderEndPosition', function () {
            updateTerminalPosition();
            $imageHoverSlider.slick('setPosition');
        });

        let wheelDelta = 0;

        $imageHoverSlider.on('wheel', function (event) {
            const originalEvent = event.originalEvent;
            const horizontalDelta = originalEvent.deltaX || (originalEvent.shiftKey ? originalEvent.deltaY : 0);

            // Preserve normal vertical page scrolling; only respond to side-scroll gestures.
            if (!horizontalDelta) {
                return;
            }

            event.preventDefault();
            wheelDelta += horizontalDelta;

            if (Math.abs(wheelDelta) < 40) {
                return;
            }

            $imageHoverSlider.slick(wheelDelta > 0 ? 'slickNext' : 'slickPrev');
            wheelDelta = 0;
        });

        $section.find('.image-hover-slider-arrows .prev').on('click', function () {
            $imageHoverSlider.slick('slickPrev');
        });
        $section.find('.image-hover-slider-arrows .next').on('click', function () {
            $imageHoverSlider.slick('slickNext');
        });
    });

    // Home Testimonial Slider
    var $homeSliderWorkShop = $('.home-workshop-slider');
    if ($homeSliderWorkShop.length) {
        $homeSliderWorkShop.slick({
            infinite: true,
            autoplay: false,
            fade: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
        });
        $('.workshop-arrow.prev').on('click', function () {
            $homeSliderWorkShop.slick('slickPrev');
        });
        $('.workshop-arrow.next').on('click', function () {
            $homeSliderWorkShop.slick('slickNext');
        });
    }

    // EATS & TREATS — AJAX search, tabs filter, load more 
    let etPage = 1;
    const ET_AJAX_URL = window.location.origin + "/wp-admin/admin-ajax.php";
    // helper
    function currentTypeFilters() {
        const ids = [];
        if (!$('.eats-treats-section .all-btn').hasClass('active')) {
            $('.eats-treats-section .select-btn.active').each(function () {
                const id = $(this).attr('data-id');
                if (id) ids.push(id);
            });
        }
        return ids;
    }

    function currentSearch() {
        return $('.eats-treats-section input[name="et-search"]').val()?.trim() || '';
    }

    function renderLoading(targetSel) {
        $(targetSel).html(
            '<p class="full-loading-cell text-center col-12" role="status">Loading Eats &amp; Treats…</p>'
        );
    }

    function fetchAndRender(opts, { replace = true } = {}) {
        const $results = $(".eats-treats-post-listing .et-card-row");
        const data = Object.assign({
            action: 'filter_eats_treats',
            page: etPage
        }, opts);

        if (replace) {
            lockFilterResultsHeight($results);
            renderLoading(".eats-treats-post-listing .et-card-row");
        } else {
            $(".eats-treats-post-listing .load-more-content").html(
                '<p class="text-center" role="status">Loading Eats &amp; Treats…</p>'
            );
        }

        $.ajax({
            type: 'POST',
            url: ET_AJAX_URL,
            data
        }).done(function (markup) {
            if (replace) {
                $results.html(markup);
            } else {
                $(".eats-treats-post-listing .load-more-content").remove();
                $(".eats-treats-post-listing .et-card-row").append(markup);
            }
        }).always(function () {
            if (replace) {
                releaseFilterResultsHeight($results);
            } else {
                refreshFilterScrollTriggers($results);
            }
        });
    }

    // Search (keyup)
    $('.eats-treats-section input[name="et-search"]').on('keyup', function () {
        etPage = 1;
        const typeFilters = currentTypeFilters();
        const search = currentSearch();
        const sort = $('#et-sort').val() || 'latest';

        fetchAndRender({ type_filters: typeFilters, search, sort }, { replace: true });
    });

    // Tabs filter (only categories)
    $('.eats-treats-section .select-btn').on('click', function () {
        etPage = 1;
        // clear search when clicking filters
        $('.eats-treats-section .et-input-wrapper input').val('');

        if ($(this).hasClass('all-btn')) {
            $('.eats-treats-section .select-btn').removeClass('active');
            $(this).addClass('active');
        } else {
            $('.eats-treats-section .all-btn').removeClass('active');
            $(this).toggleClass('active');
            // If none selected, fall back to All
            if ($('.eats-treats-section .select-btn.active').not('.all-btn').length === 0) {
                $('.eats-treats-section .all-btn').addClass('active');
            }
        }

        const typeFilters = currentTypeFilters();
        const sort = $('#et-sort').val() || 'latest';

        fetchAndRender({ type_filters: typeFilters, sort }, { replace: true });
    });

    // Sort select change
    $('.eats-treats-section #et-sort').on('change', function () {
        etPage = 1;
        const typeFilters = currentTypeFilters();
        const search = currentSearch();
        const sort = $(this).val();

        fetchAndRender({ type_filters: typeFilters, search, sort }, { replace: true });
    });

    // Support URL param ?type=Name or ?type=A,B
    if ($('.eats-treats-section .select-btn').length) {
        const urlParams = new URLSearchParams(window.location.search);
        let type = urlParams.get('type');
        if (type) {
            const sep = type.includes(',') ? ',' : (type.includes('%2c') ? '%2c' : '');
            if (sep) {
                type.split(sep).forEach((text) => {
                    $('.eats-treats-section').find(`.select-btn[data-type='${decodeURIComponent(text)}']`).trigger('click');
                });
            } else {
                $('.eats-treats-section').find(`.select-btn[data-type='${decodeURIComponent(type)}']`).trigger('click');
            }
        }
    }

    // Load more
    $('.eats-treats-section').on('click', '.et-load-more', function () {
        etPage = etPage + 1;
        const typeFilters = currentTypeFilters();
        const search = currentSearch();
        const sort = $('#et-sort').val(); // current sort
        fetchAndRender({ type_filters: typeFilters, search, sort }, { replace: false });
    });


    // Same width button on home page
    var btnMaxWidth = 0;
    $('.home-market-cards-section .cta-btn-group .theme-btn').each(function () {
        var thisWidth = $(this).outerWidth();
        if (thisWidth > btnMaxWidth) {
            btnMaxWidth = thisWidth;
        }
    });
    $('.home-market-cards-section .cta-btn-group .theme-btn').css('width', btnMaxWidth + 'px');
});

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// HOME PAGE V2 (First section Padding)
// function setHeroPadding() {
//     var headerHeight = $('header.site-header').outerHeight();
//     if (headerHeight < 100) headerHeight = 100;
//     $('.home-banner .content, .experience-video-section .inner-wrapper').css('padding-top', headerHeight + 'px');
// }
// Run on page load
// $(document).ready(function () {
//     setHeroPadding();
// });
// // Also run on window resize (in case header height changes)
// $(window).on('resize', function () {
//     setHeroPadding();
// });

// Counter Number JS
var counterNumVal = 0;
$(window).scroll(function () {
    if ($('body').hasClass('page-template-new-home-page')) {
        var counterOffsetTop = $("#counter-box").offset().top - window.innerHeight;
        if (counterNumVal == 0 && $(window).scrollTop() > counterOffsetTop) {
            $(".counter").each(function () {
                var $this = $(this), countTo = $this.attr("data-number");
                $({ countNum: $this.text() }).animate({
                    countNum: countTo
                }, {
                    duration: 3000,
                    easing: "swing",
                    step: function () {
                        $this.text(
                            Math.ceil(this.countNum).toLocaleString("en")
                        );
                    },
                    complete: function () {
                        $this.text(
                            Math.ceil(this.countNum).toLocaleString("en")
                        );
                    }
                });
            });
            counterNumVal = 1;
        }
    }
});


$(document).ready(function () {
    var $videos = $('.short-videos-area .video-block video');
    var totalVideos = $videos.length;
    var middleIndex = Math.floor(totalVideos / 2);

    // Autoplay only middle video
    $videos.each(function (index) {
        var $block = $(this).closest('.video-block');
        var $btn = $block.find('.play-push-btn');

        if (index === middleIndex) {
            this.play();  // middle autoplay
            $btn.addClass('playing'); //Add playing class on its button
        } else {
            this.pause(); // Other videos paused
            $btn.removeClass('playing'); // Ensure no playing class
        }
    });

    // Play/Pause toggle
    $('.short-videos-area').on('click', '.play-push-btn', function () {
        var $block = $(this).closest('.video-block');
        var video = $block.find('video').get(0);

        if (video.paused) {
            video.play();
            $(this).addClass('playing');
        } else {
            video.pause();
            $(this).removeClass('playing');
        }
    });

    // Sound toggle on .short-vid-btn
    $('.short-videos-area').on('click', '.short-vid-btn', function () {
        var $block = $(this).closest('.video-block');
        var video = $block.find('video').get(0);

        if ($(this).hasClass('off')) {
            video.muted = false;
            $(this).removeClass('off');
        } else {
            video.muted = true;
            $(this).addClass('off');
        }
    });
});

// Fixed Scrolling Arrow ~ Home page
$(document).ready(function () {
    let $arrow = $('.scrolling-arrow');

    if ($arrow.length) {
        let $arrowSection = $('.home-market-cards-section'); // parent section of arrow
        let $hideSection = $('.memories-video-section h2'); // section where arrow hides

        function handleArrow() {
            if (!$arrowSection.length || !$hideSection.length) {
                $arrow.removeClass('active hide');
                return;
            }

            let scrollTop = $(window).scrollTop();
            let windowHeight = $(window).height();
            let arrowTop = $arrowSection.offset().top;
            let hideTop = $hideSection.offset().top;

            // Mobile responsive: always active on small screens
            if ($(window).width() <= 768) {
                $arrow.addClass('active');
                if (scrollTop + windowHeight >= hideTop) {
                    $arrow.addClass('hide');
                } else {
                    $arrow.removeClass('hide');
                }
                return;
            }

            // Hide arrow when reaching hide section (desktop)
            if (scrollTop + windowHeight >= hideTop) {
                $arrow.removeClass('active').addClass('hide');
                return;
            } else {
                $arrow.removeClass('hide');
            }

            // Add active only when reaching arrow section (desktop)
            if (scrollTop + windowHeight >= arrowTop) {
                $arrow.addClass('active');
            } else {
                $arrow.removeClass('active');
            }
        }

        handleArrow(); // Initial check
        $(window).on('scroll resize', handleArrow);
    }
});
